import { MaybeJwtUser } from "@notemeal/shared/ui/utils/tokens";
import { TableRecipeFragment } from "apps/web/src/types";

export const isRecipeOwner = (recipe: TableRecipeFragment, user: MaybeJwtUser) => {
  return user ? user.id === recipe.owner.id : false;
};
